import { MembershipRoles } from '../data-models/membership-roles.model';

/** The membership role bits an admin can set directly (Owner and Chief Supervisor are organization fields). */
export function calculateBitwiseRole(isPilot: boolean, isPIC: boolean): number {
  let role = 0;
  if (isPilot) {
    role |= MembershipRoles.Pilot;
  }
  if (isPIC) {
    role |= MembershipRoles.PilotInCharge;
  }
  return role;
}

/** A role change is valid when the new role is within the Pilot / PIC bits (0-3). The hub checks the rest. */
export function validateRoleChange(currentRole: number, newRole: number): { valid: boolean; error?: string } {
  if (newRole < 0 || newRole > 3) {
    return { valid: false, error: 'Invalid role value. Must be between 0 and 3.' };
  }
  return { valid: true };
}

/** In the admin portal, any admin can change a member's role. */
export function canChangeRole(isAdmin: boolean): boolean {
  return isAdmin;
}

/** The Pilot / PIC role names in `role`. */
export function getRoleDisplayNames(role: number): string[] {
  const roles: string[] = [];
  if (hasRoleBit(role, MembershipRoles.Pilot)) {
    roles.push('Pilot');
  }
  if (hasRoleBit(role, MembershipRoles.PilotInCharge)) {
    roles.push('Pilot in Command');
  }
  return roles;
}

/** Whether `role` has every bit of `bit`. */
export function hasRoleBit(role: number, bit: MembershipRoles): boolean {
  return (role & bit) === bit;
}
